export default __webpack_public_path__ + "94921dfc96168c29bb60fc25537b6caf.png";